import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>404 Page Not Found | SwiftMaze Tech</title>
        <meta
          name="description"
          content="The page you requested could not be found on SwiftMaze Tech."
        />
        <meta name="robots" content="noindex,follow" />
        <link rel="canonical" href="https://www.swiftmazetech.com/404" />
      </Helmet>

      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "#f5f7fa",
          padding: "20px",
          textAlign: "center",
        }}
      >
        <h1 style={{ fontSize: "80px", fontWeight: "bold", color: "#333" }}>404</h1>
        <h2 style={{ fontSize: "28px", color: "#555", marginBottom: "10px" }}>
          Page Not Found
        </h2>
        <p style={{ maxWidth: "350px", color: "#777", marginBottom: "20px" }}>
          The page you&apos;re trying to access doesn&apos;t exist or may have been moved.
        </p>

        <Link
          to="/"
          style={{
            padding: "12px 24px",
            background: "#3595E4",
            color: "white",
            borderRadius: "6px",
            textDecoration: "none",
            fontSize: "16px",
          }}
        >
          Go Back Home →
        </Link>
      </div>
    </>
  );
}
